<template>
    <v-dialog value="true" fullscreen hide-overlay persistent content-class="analise__scroll">
        <v-card tile color="#fff">
            <analise-documentacao-cabecalho v-model="compraDireta.analiseDocumentos"
                                            @voltar="tratarEventoDeVoltar"/>
            <v-card-text class="analise__area" v-if="analiseDocs.documentosAnalizaveis
                                                     && analiseDocs.documentosNaoAnalizaveis">
                <analise-documentacao-menu v-if="exibir"
                                           v-model="compraDireta.analiseDocumentos"
                                           :situacaoCompraDireta="compraDireta.analiseDocumentos.situacao"
                                           @baixarTodosDocumentos="tratarEventoBaixarTodosDocumentos"
                                           @documentoSelecionado="tratarEventoDeSelecionarDocumento"/>

                <analise-documentacao-documento v-if="exibir"
                                                :documento="documentoSelecionadoAtual"
                                                :situacaoCompraDireta="compraDireta.analiseDocumentos.situacao"
                                                :situacao-compra-enum="compraDireta.analiseDocumentos.situacaoCompra"
                                                :situacaoItemLote="compraDireta.analiseDocumentos.situacaoItemLote"
                                                :situacaoFornecedor="compraDireta.analiseDocumentos.situacaoFornecedor"
                                                :itemLoteTipo="itemLoteTipo"
                                                :virtualizacao="compraDireta.analiseDocumentos.ehCompraDiretaVirtualizada"
                                                @solicitarReenvio="tratarEventoDeSolicitarReenvio"
                                                @solicitarEnvioDocumento="tratarEventoDeSolicitarEnvio"
                                                @solicitarAssinatura="solicitarAssinatura"
                                                @downloadDocumento="tratarEventoDownload"/>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
import {mapState} from 'vuex'
import {actionTypes} from '@/core/constants'
import AnaliseDocumentacaoCabecalho
from '@/views/pages/comprador/analise-documentacao/cabecalho/AnaliseDocumentacaoCabecalho'
import AnaliseDocumentacaoMenu from '@/views/pages/comprador/analise-documentacao/menu/AnaliseDocumentacaoMenu'
import AnaliseDocumentacaoDocumento
from '@/views/pages/comprador/analise-documentacao/documento/AnaliseDocumentacaoDocumento'
import azAuth from '@azinformatica/loki/src/utils/az-auth'

export default {
    name: 'AnaliseDocumentacao',
    components: {
        AnaliseDocumentacaoCabecalho,
        AnaliseDocumentacaoDocumento,
        AnaliseDocumentacaoMenu
    },
    data() {
        return {
            compraDiretaId: null,
            fornecedorId: null,
            itemLoteId: null,
            itemLoteTipo: null,
            documentoSelecionadoAtual: {
                url: ''
            },
            exibir: false
        }
    },
    computed: {
        ...mapState(['compraDireta', 'parametros', 'loki']),
        analiseDocs() {
            const base = (this.compraDireta && this.compraDireta.analiseDocumentos) || {}
            const documentosAnalizaveis = Array.isArray(base.documentosAnalizaveis) ? base.documentosAnalizaveis : []
            const documentosNaoAnalizaveis = Array.isArray(base.documentosNaoAnalizaveis) ? base.documentosNaoAnalizaveis : []
            return {
                documentosAnalizaveis,
                documentosNaoAnalizaveis,
                situacao: base.situacao || null,
                situacaoCompra: base.situacaoCompra || null,
                situacaoItemLote: base.situacaoItemLote || null,
                situacaoFornecedor: base.situacaoFornecedor || null,
                ehCompraDiretaVirtualizada: Boolean(base.ehCompraDiretaVirtualizada)
            }
        },
        devePermitirAnalisarDocumento(){
            return azAuth(this.loki.user.authorities, ['Comprador.Normal', 'Comprador.Admin', 'Comprador.Autoridade.Superior'])
        }
    },
    async mounted() {
        try {
            this.receberDadosDaRota()
            await this.buscarDocumentosParaAnalisar()
            await this.exibirAnalise()
        } catch (e) {
            this.mostrarNotificacaoErro(e.message)
        }
    },
    methods: {
        async buscarDocumentosParaAnalisar() {
            const dados = {
                compraDiretaId: this.compraDiretaId,
                fornecedorId: this.fornecedorId,
                itemLoteId: this.itemLoteId,
                itemLoteTipo: this.itemLoteTipo
            }
            await this.$store.dispatch(actionTypes.COMPRADOR.BUSCAR_ANALISE_DOCUMENTOS_DO_FORNECEDOR, dados)
            if (this.analiseDocs.documentosAnalizaveis.length > 0) {
                this.documentoSelecionadoAtual = this.analiseDocs.documentosAnalizaveis[0]
            }
        },
        async tratarEventoDeSelecionarDocumento(comboAnaliseDocumentacaoMenu) {
            this.documentoSelecionadoAtual = comboAnaliseDocumentacaoMenu.documento

            if(!this.devePermitirAnalisarDocumento) return

            if (comboAnaliseDocumentacaoMenu.novaSituacao) {
                const dados = {
                    compraDiretaId: this.compraDiretaId,
                    fornecedorId: this.fornecedorId,
                    documentoSolicitadoId: comboAnaliseDocumentacaoMenu.documento.documentoSolicitadoId,
                    documentoApresentadoId: comboAnaliseDocumentacaoMenu.documento.id,
                    situacao: comboAnaliseDocumentacaoMenu.novaSituacao
                }
                await this.$store.dispatch(actionTypes.COMPRADOR.ATUALIZAR_ANALISE_DE_DOCUMENTO_SELECIONADO, dados)
            }
        },
        async tratarEventoDeSolicitarReenvio(comboAnaliseDocumentacaoDocumento) {
            const dados = {
                compraDiretaId: this.compraDiretaId,
                fornecedorId: this.fornecedorId,
                documentoSolicitadoId: comboAnaliseDocumentacaoDocumento.documentoSolicitadoId,
                documentoApresentadoId: comboAnaliseDocumentacaoDocumento.documentoApresentadoId,
                situacao: comboAnaliseDocumentacaoDocumento.novaSituacao,
                motivoReenvio: comboAnaliseDocumentacaoDocumento.motivoReenvio
            }
            await this.$store.dispatch(actionTypes.COMPRADOR.ATUALIZAR_ANALISE_DE_DOCUMENTO_SELECIONADO, dados)
            this.mostrarNotificacaoSucesso('Solicitação de reenvio de documento enviada com sucesso.')
        },
        async tratarEventoDeSolicitarEnvio(documento) {
            const dados = {
                compraDiretaId: this.compraDiretaId,
                fornecedorId: this.fornecedorId,
                documentoSolicitadoId: documento.documentoSolicitadoId,
                documentoApresentadoId: documento.documentoApresentadoId,
                mensagem: documento.mensagem
            }
            await this.$store.dispatch(actionTypes.COMPRADOR.SOLICITAR_ENVIO_DO_DOCUMENTO_SELECIONADO, dados)
            this.mostrarNotificacaoSucesso('Solicitação de envio de documento enviada com sucesso.')
        },
        async solicitarAssinatura(comboSolicitarAssinaturaDocumento) {
            const signatarios = comboSolicitarAssinaturaDocumento.signatarios || []
            const signatario = signatarios.find(s => String(s.pessoaId) === String(this.fornecedorId))
            const possuiAssinaturaExpirada = signatario ? signatario.situacao === 'EXPIRADO' : false
            const conviteId = signatario ? signatario.id : null

            const dados = {
                compraDiretaId: this.compraDiretaId,
                fornecedorId: this.fornecedorId,
                documentoId: comboSolicitarAssinaturaDocumento.documentoId,
                tipoDocumento: comboSolicitarAssinaturaDocumento.tipoDocumento,
                descricaoDocumento: comboSolicitarAssinaturaDocumento.descricao,
                documentoVirtualizadoId: comboSolicitarAssinaturaDocumento.idVirtualizado,
                renovarAssinatura: possuiAssinaturaExpirada,
                conviteId: conviteId
            }
            await this.$store.dispatch(actionTypes.COMPRADOR.SOLICITAR_ASSINATURA_DO_DOCUMENTO_SELECIONADO, dados)
            await this.atualizarDocumentosParaAnalisar()
            this.mostrarNotificacaoSucesso('Assinatura solicitada com sucesso.')
        },
        async exibirAnalise() {
            this.exibir = true
        },
        async atualizarDocumentosParaAnalisar() {
            const dados = {
                compraDiretaId: this.compraDiretaId,
                fornecedorId: this.fornecedorId,
                itemLoteId: this.itemLoteId,
                itemLoteTipo: this.itemLoteTipo
            }
            await this.$store.dispatch(actionTypes.COMPRADOR.BUSCAR_ANALISE_DOCUMENTOS_DO_FORNECEDOR, dados)
            const documentos = this.analiseDocs.documentosAnalizaveis
            if (documentos.length === 0) {
                this.documentoSelecionadoAtual = null
                return
            }

            const documentoAtualNaLista = documentos.find(doc => doc.id === (this.documentoSelecionadoAtual && this.documentoSelecionadoAtual.id))

            if (documentoAtualNaLista) {
                this.documentoSelecionadoAtual = { ...documentoAtualNaLista }
            } else {
                this.documentoSelecionadoAtual = documentos[0]
            }
        },
        tratarEventoDownload(documento) {
            this.$store.dispatch(actionTypes.COMPRADOR.BAIXAR_DOCUMENTO_DO_FORNECEDOR,
                {nome : this.getNome(documento), ...documento})
        },
        getNome(documento){
            if(documento.descricao)
                return documento.descricao.replaceAll(' ', '_')
            return 'documento_' + (new Date()).getTime()
        },
        tratarEventoDeVoltar() {
            this.$router.push({
                name: 'Resultado',
                params: {
                    id: this.compraDiretaId
                }
            })
        },
        receberDadosDaRota() {
            this.compraDiretaId = this.$route.params.id
            this.fornecedorId = this.$route.params.fornecedorId
            this.itemLoteId = this.$route.params.itemLoteId
            this.itemLoteTipo = this.$route.params.itemLoteTipo
        },
        async tratarEventoBaixarTodosDocumentos() {
            const data = {
                compraDiretaId: this.compraDiretaId,
                pessoaId: this.fornecedorId,
                razaoSocial: this.nomeZip() || 'apresentados'
            }
            await this.$store.dispatch(actionTypes.COMPRADOR.BAIXAR_TODOS_DOCUMENTOS_APRESENTADOS, data)
        },
        nomeZip(){
            if(this.compraDireta && this.compraDireta.analiseDocumentos)
                return this.compraDireta.analiseDocumentos.razaoSocial

            return null
        }
    }
}
</script>

<style scoped lang="stylus">
    .analise__area
        padding 0
        margin 0
        overflow-y auto
        padding-top 64px
        display flex

    @media (max-width 960px)
        .analise__area
            padding-top 48px

    @media (max-width 670px)
        .analise__area
            padding-top 56px
</style>